import React, { useEffect } from 'react';

import './Header.scss';
//import { IconArrowUpRightTeal, IconHamburgher, IconHeaderCloud, IconLogo } from '../Icons';
import { IconHamburgher, IconLogo } from '../Icons';
//import useWindowSize from '../../hooks/useWindowSize';
import { MOBILE_OPEN } from '../../utils/constants';
//import useWindowSize from '../../hooks/useWindowSize';
//import SearchBar from '../SearchBar/SearchBar';

export default function Header(): React.ReactElement {
  //const { isMobile } = useWindowSize();

  useEffect(() => {
    localStorage.setItem(MOBILE_OPEN, null);
  }, []);

  return (
    <header className="header">
      <a tabIndex={1} className="header__logo" href={process.env.GATSBY_DOCS_URL}>
        <IconLogo />
      </a>
      {/* {!isMobile && (
        <>
          <SearchBar />
          <div>
            <a tabIndex={3} href={process.env.GATSBY_CLOUD_URL}>
              <IconHeaderCloud />
            </a>
            <a tabIndex={3} href={process.env.GATSBY_ARDUINO_URL} className="header__arduino-cc">
              <span>ARDUINO.CC</span> <IconArrowUpRightTeal />
            </a>
          </div>
        </>
      )} */}

      {/* Hide that isMobile when return to Arduino Header */}
      {/* {isMobile && ( */}
      <button
        className="header__navigation"
        onClick={() => {
          localStorage.setItem(MOBILE_OPEN, localStorage.getItem(MOBILE_OPEN) === 'opened' ? 'closed' : 'opened');
        }}
      >
        <IconHamburgher />
      </button>
      {/* )} */}
    </header>
  );
}
